import { UAParser } from "ua-parser-js";

import { Device } from "../types/common";

export const getDevice = (userAgent: string = navigator.userAgent): Device => {
  const { browser, device, os } = UAParser(userAgent);
  return {
    browser,
    isMobile: device.type === "mobile" || device.type === "tablet",
    os
  };
};
